<template>
  <div>
    <router-view></router-view>
    <v-footer />
  </div>
</template>

<script>
import VFooter from "../components/v-footer";

export default {
  name: "chosen-med-type",
  components: {
    VFooter
  }
};
</script>

<style scoped></style>
